import { css } from 'reakit/styled';
import { theme } from 'styled-tools';
import 'styled-selector';
import '../styled/selector.js';
import 'lodash/get';
import space from '../styled/space.js';
import styled from '../styled/index.js';
import Box from 'reakit/Box';
import 'reakit/Block';
import 'reakit/Inline';
import 'reakit/InlineBlock';
import 'reakit/Flex';
import 'reakit/InlineFlex';
import 'reakit/Grid';
import _List from 'reakit/List';
var orderedProperties = css(["list-style-type:decimal;& &{list-style-type:lower-alpha;}& & &{list-style-type:lower-roman;}&{", ";}"], theme('fannypack.List.ordered'));
var horizontalProperties = css(["& li{display:inline-block;margin-right:1rem;margin-bottom:unset;}&{", ";}"], theme('fannypack.List.horizontal'));
var ListItem = styled(Box).withConfig({
  displayName: "styled__ListItem",
  componentId: "wo6si3-0"
})(["margin-bottom:0.2rem;&{", ";}"], theme('fannypack.List.item.base'));
var List = styled(_List).withConfig({
  displayName: "styled__List",
  componentId: "wo6si3-1"
})(["list-style:unset;list-style-type:none;&:not(:last-child){margin-bottom:", "rem;}& &{margin-left:", "rem;}&{", ";}&{", ";}&{", ";}"], space(4), space(4), function (props) {
  return props.isOrdered && orderedProperties;
}, function (props) {
  return props.isHorizontal && horizontalProperties;
}, theme('fannypack.List.base'));
export default List;
export { List, ListItem, horizontalProperties, orderedProperties };